export default {"src":"/seller-forums/_next/static/media/privateDiscussion.13228320.svg","height":96,"width":96};